<template>
  <BootstrapTable
    :columns="columns"
    :data-url="data"
    :options="options"
    data-side-pagination="server"
    data-pagination="true"
    data-buttons-class="outline-primary"
  />
</template>

<script>
import BootstrapTable from 'bootstrap-table/dist/bootstrap-table-vue.esm.js'

export default {
  components: {
    BootstrapTable
  },
  data () {

  	var vm = this;

    return {
      columns: [
        {
          field: 'first_name',
          title: 'First Name',
          sortable: true
        },
        {
          field: 'last_name',
          title: 'Last Name',
          sortable: true
        },
        {
          field: 'company_name',
          title: 'Company',
          sortable: true
        },
        {
          field: 'email',
          title: 'Email',
          sortable: true
        },

        {
          field: 'telephone',
          title: 'Telephone',
          sortable: true
        },
        {
          field: 'tools',
          title: 'Tools',
          formatter: function(value, row, index){
            return [
                '<a class="table-control btn btn-outline-primary btn-sm select-contact"  href="javascript:void(0)" title="Select Contact">',
                '<i class="fa fa-user"></i> Select',
                '</a>',
                '</a>'
              ].join('');
          },
          width: 130,
          align: 'center',
          events: {
              'click .select-contact': function (e, value, row) {
                vm.$emit('selectContact', row.id);
              }
            }
        }
      ],
      //data: '/contacts/list/filtered/has-tel',
      data: '/contacts/list',
      options: {
        search: true,
      }
    }
  }
}




</script>